import classnames from 'classnames';
import React, { FC } from 'react';
import styles from './Truncated.scss';

export const Truncated: FC<{ children: string; className?: string }> = ({ children, className }) => (
  <span className={classnames(styles.truncated, className)} title={children}>
    {children}
  </span>
);
